import { parseHtmlString } from "@/utils/helpers/html";
import { Heading, Paragraph } from "@/components/ui/Typography"
import { WebsitePageSection } from "@/types"
import EditableSection from "@/components/admin/Content/WebPages/EditableSection";


const FeaturesCard = ({data}:{data: WebsitePageSection}) => {
  return (
    <EditableSection
      sectionTag={data.sectionTag}
      contentType={data.contentType}
      data={data}
    >
      <div className="flex flex-col gap-4 h-full bg-[#F2F2F2] p-4 lg:p-6">
        <img src={data.fileUrl ?? "/blank-image-placeholder.png"} alt={data.title ?? "Historical Timeline"} className="w-full object-cover h-60" />
        <div className="flex items-center gap-4">
          <Heading level={4} >{data.title ?? "Default Title"}</Heading>
        </div>
        <Paragraph dangerouslySetInnerHTML={parseHtmlString(data.description ?? "Default Description")} />
      </div>
    </EditableSection>
  )
}

export default FeaturesCard